import { Navigate, Route, Routes } from 'react-router';
import { LoginPage } from '@/auth/LoginPage';
import { PERMISSIONS } from '@/auth/permissions';
import { RequireAuth } from '@/auth/RequireAuth';
import { RequirePermission } from '@/auth/RequirePermission';
import { AppShell } from '@/shared/AppShell';
import { ForecastPage } from '@/pages/forecast/ForecastPage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { VehiclesPage } from '@/pages/vehicles/VehiclesPage';

/** Route table — the only file that imports pages (lint-enforced). */
export function App() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<RequireAuth />}>
                <Route element={<AppShell />}>
                    <Route element={<RequirePermission permission={PERMISSIONS.DISPO} />}>
                        <Route index element={<Navigate to="/forecast" replace />} />
                        <Route path="/forecast" element={<ForecastPage />} />
                        <Route path="/vehicles" element={<VehiclesPage />} />
                        <Route path="/settings" element={<SettingsPage />} />
                    </Route>
                </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
